"use strict";

module.exports = {
  'name': 'row',
  'category': 'Matrix',
  'syntax': ['row(x, index)'],
  'description': 'Return a row from a matrix or array.',
  'examples': ['A = [[1, 2], [3, 4]]', 'row(A, 1)', 'row(A, 2)'],
  'seealso': ['column']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/matrix/row.js
// module id = 903
// module chunks = 0